// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3bNFk","header":"Messages_header__2-xuq"};